import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import useLogo from "../../hooks/useLogo";

const AboutUsBanner = () => {
  const { data: logoUrl } = useLogo();
  return (
    <div className="py-16 px-4 max-w-5xl mx-auto">
      <div className="flex flex-col md:flex-row gap-10 items-center bg-white rounded-lg shadow-lg overflow-hidden">
        {/* Logo/Image section */}
        <div className="md:w-1/3 flex justify-center items-center bg-primary/5 py-8">
          <img
            src={logoUrl || "/logo.png"}
            alt="NNS Logo"
            className="rounded-lg shadow-md object-contain max-h-44 max-w-xs bg-white p-4"
            style={{ width: 220, height: 120 }}
          />
        </div>

        {/* Text and Button section */}
        <div className="md:w-2/3 flex flex-col justify-center p-8">
          <h2 className="text-2xl md:text-3xl font-bold text-primary mb-4 leading-snug">
            নিঃস্বার্থ নবজীবন সংগঠন - NNS
          </h2>
          <p className="mb-6 text-gray-700 leading-relaxed">
            নিঃস্বার্থ নবজীবন সংগঠন (NNS) - একটি অরাজনৈতিক, অলাভজনক, সামাজিক ও
            সেবামূলক সংগঠন। অস্থায়ী কার্যালয়ঃ খলিফা পট্টি, আন্দরকিল্লা,
            চট্টগ্রাম।
          </p>
          <Link
            to="/about"
            className="inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-white font-bold py-3 px-6 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg w-max"
          >
            <Heart className="h-5 w-5" />
            বিস্তারিত
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AboutUsBanner;
